// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, switchMap } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { Expertise } from '../models/expertise';
import { BaseService } from './base.service';
import { Prestation } from '../models/prestation';

@Injectable({
  providedIn: 'root'
})
export class PrestationService extends BaseService {


  my(): Observable<Prestation[]> {

      let params = new HttpParams()
        .set('sort', '-id')
        .set('page', '1')
        .set('per-page', '10');

    return this.http
      .get<Prestation[]>(this.basePath + '/v1/prestations/my?expand=expertise,workflow,type,user', {params: params})
      .pipe(        
        map(m => m.map(p => Object.assign(new Prestation, p))),
        catchError(this.handleError)
      );
  }  


  update(prestation: any): Observable<Prestation> {
    if (prestation.expertise_id && prestation.expertise_id.id) {
      prestation.expertise_id = prestation.expertise_id.id;
    }
    if (prestation.id >= 0) {
      return this.http
        .put<Prestation>(this.basePath + '/v1/prestations/' + prestation.id+ "?expand=expertise,expertise.workflow,workflow,type,user", prestation)
        .pipe(
          map((o: any) => Object.assign((new Prestation), o)),
          catchError(this.handleError)
        );
     } 
      return this.http
        .post<Prestation>(this.basePath + '/v1/prestations?expand=expertise,expertise.workflow,workflow,type,user', prestation)
        .pipe(
          map((o: any) => Object.assign((new Prestation), o)),
          catchError(this.handleError)
        );

  }


  create(expertiseId: number, prestation: any): Observable<Prestation> {
    if (prestation.id >= 0) {
      return this.http
        .post<Prestation>(this.basePath + '/v1/prestations?expand=expertise,expertise.workflow,workflow,type,user', Object.assign(prestation, {expertiseId: expertiseId}))
        .pipe(
          map((o: any) => Object.assign((new Prestation), o)),
          catchError(this.handleError)
        );
    }
  }

  delete(id: number): Observable<any> {
    return this.http
      .delete<any>(this.basePath + '/v1/prestations/' + id)
      .pipe(        
        catchError(this.handleError)
      );
  }  


}
